<template>
  <div class="Home">
    <div class="personal">
      <div class="identity">
        <div class="portrait">
          <img src="../assets/pic.png" alt/>
        </div>
        <div class="account">
          <span v-show="login_bol">{{ mobile }}</span>
          <span v-show="login_bol" class="license">{{ car_num }}</span>
          <span @click="gologin" v-show="!login_bol" class="gologin"><span>登录</span></span>
        </div>
        <div @click="goexit" class="exit" v-show="login_bol">
          <span class="iconfont icon-xiangyou-copy"></span>
        </div>
      </div>
      <div class="tab">
        <div @click="goBillList">
          <span>{{ last_share }}</span>
          <span>最新分配</span>
        </div>
        <div @click="golineItem">
          <span>{{ order_num }}</span>
          <span>订单明细</span>
        </div>
        <div @click="goSiteList">
          <span>加油站</span>
          <span>站点地图</span>
        </div>
      </div>
      <div style="font-size:0.45rem;">撬装点余额</div>
      <div class="car_list" v-for="item in card_list" :key="item.id" @click="goassignationManagement(item.id,item.card_name)">
        <span>{{ item.card_name }} {{ item.car_number }}</span>
        <span>{{ item.oil_store }}升</span>
      </div>
      <div style="font-size:0.45rem;padding:0.5rem 1rem 0 1rem">加油站余额</div>
      <div class="car_list" v-for="item in card_list" :key="item.id" @click="goassignationManagement(item.id,item.card_name)">
        <span>{{ item.card_name }} {{ item.car_number }}</span>
        <span>{{ item.money }}元</span>
      </div>
    </div>
    <div class="code_wrap">
      <div @click="scan">
        <span class="iconfont icon-saoyisaojianjiban"></span>
        <span>扫码加油</span>
      </div>
    </div>
    <div style="font-size:0.4rem;padding:0rem 0rem 3rem 0.2rem;height:2rem;width:95%;flex-direction:column;">
      欢迎使用图油！！！
      <!--
      <a href="tel:13166250172">支付问题联系：13166250172</a>
      <a href="tel:17600707615">投诉和建议电话：17600707615</a>
      <a href="tel:15300807186">有合作意向的客户请联系：15300807186</a>
      -->
    </div>
    <!-- 车牌未绑定，弹出提示框 -->
    <div v-show="nocar_num_show" class="nocar_num">
      <span class="nocar_num_text">车牌未绑定，请联系车队做司机车牌绑定操作</span>
      <span @click="nocarBt" class="nocar_num_bt">确认</span>
    </div>
    <tabbar :selected="selected"></tabbar>
  </div>
</template>

<script>
import common from "../common";
import wx from "weixin-js-sdk";
import {MessageBox} from 'mint-ui';
import tabbar from '@/components/tabbar'

export default {
  name: "Home",
  components: {tabbar},
  data() {
    return {
      selected: "home",
      login_bol: false, //是否登录
      mobile: "",
      order_num: "", //订单总数
      card_list: "", //加油卡列表
      last_share: "", //最新分配数量
      car_num: "",
      nocar_num_show: false
    };
  },
  methods: {
    gologin() {
      this.$router.replace("login");
    },
    goexit() {
      this.$router.push("exit");
    },
    nocarBt() {
      this.$router.push("login");
    },
    scan() {
      wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode",
        success: res => {
          const url = res.resultStr;
          if (url) {
            let arr = url.split("#");
            if (arr[0] != "http://driver.tiger.baiduwebs.top/" && arr[0] != "https://driver.tiger.baiduwebs.top/" &&
                arr[0] != "http://oil-driver.baiduwebs.top/" && arr[0] != "https://oil-driver.baiduwebs.top/") {
              MessageBox('警告', '错误的二维码,请使用图油的二维码！');
              return;
            }
            if (arr[1]) {
              let param = arr[1].split("/");
              this.$router.push({
                path: '/createOrder/' + param[2]
              });
            }
          }
        }
      });
    },
    goassignationManagement(card_id, card_name) {
      let obj = {
        id: card_id,
        card_name: card_name
      };
      let card_obj = JSON.stringify(obj);
      this.$router.push({
        path: "/assignationManagement/" + card_obj
      });
    },
    golineItem() {
      this.$router.push("lineItem");
    },
    goSiteList() {
      this.$router.push("siteList");
    },
    goBillList() {
      this.$router.push("billList");
    },
    handler() {
      event.preventDefault(); // 阻止默认的处理方式(阻止下拉滑动的效果)
    },
    //获取用户openid
    getOpenid() {
      let url = window.location.href;
      let querystring = require("querystring");
      this.$api.post("/wx/getUrl",
          querystring.stringify({
            url
          })
      ).then(({data}) => {
        window.location.href = data;
      });
    },
    //查询用户是否绑定手机号;
    ifQueryBinding(openid) {
      let querystring = require("querystring");
      this.$api
          .post("/wx/checkOpenid",
              querystring.stringify({
                openid
              })
          )
          .then(({data}) => {
            if (data.status == 1) {
              //绑定了手机号,获取用户信息
              common.setCookie("token", data.data.token, 365);
              common.setCookie("mobile", data.data.mobile, 365);
              this.login_bol = true;
              this.mobile = data.data.mobile;
              this.getData(data.data.token);
            } else {
              //没有绑定了手机号,去登录页绑定
              this.$router.push({
                name: "login",
                query: {
                  openid: openid
                }
              });
            }
          });
    },
    //获取数据
    getData(token) {
      let querystring = require("querystring");
      this.$api.post("/wx/jsConfig",
          querystring.stringify({
            url: location.href.split("#")[0]
          })
      ).then(data => {
        wx.config({
          debug: false,
          appId: data.data.data.appId,
          timestamp: data.data.data.timestamp,
          nonceStr: data.data.data.nonceStr,
          signature: data.data.data.signature,
          jsApiList: ["scanQRCode", "onMenuShareAppMessage", "chooseImage"],
          openTagList: ["wx-open-subscribe"]
        });
      }).catch(err => {
        common.toast(err);
      });
      //获取账户分配明细和获取订单总数
      this.$api.post("wx/index",
          querystring.stringify({
            token
          })
      ).then(data => {
        if (data.data.status == 1) {
          this.last_share = data.data.data.last_share;
          this.order_num = data.data.data.order_total;
          this.card_list = data.data.data.account_list;
          if (data.data.data.car_number) {
            this.car_num = data.data.data.car_number;
          } else {
            this.nocar_num_show = true;
          }
        } else {
          this.$router.replace({
            name: "login"
          });
        }
      }).catch(err => {
        common.toast(err);
      });
    }
  },
  mounted() {
    //判断cookie中是否存在token
    let ifcookietoken = document.cookie.indexOf("token=") != -1;
    //判断地址栏上是否存在openid;
    let ifopenid = window.location.href.indexOf("openid") != -1;
    //判断是否已经登录
    if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
      this.mobile = JSON.parse(common.getlocalStorage("userInfo")).mobile;
      this.login_bol = true;
      let token = JSON.parse(common.getlocalStorage("userInfo")).token;
      this.getData(token);
    } else if (ifcookietoken) {
      this.login_bol = true;
      let token = common.getCookie("token");
      this.mobile = common.getCookie("mobile");
      this.getData(token);
    } else if (ifopenid) {
      let openid = window.location.href.split("openid=")[1].split("#/")[0];
      this.ifQueryBinding(openid);
    } else {
      this.getOpenid();
      //this.$router.replace({name: 'login'});
    }
    // 绑定事件
    document.addEventListener("touchmove", this.handler, {
      passive: false
    });
  },
  destroyed() {
    // 解绑事件
    document.removeEventListener("touchmove", this.handler, {
      passive: false
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.Home {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: -webkit-flex;
  flex-direction: column;
}

.Home > div {
  align-items: center;
  width: 100vw;
  display: -webkit-flex;
}

.personal {
  margin-top: 40px;
}

.Home .personal {
  background: white;
  flex-direction: column;
  justify-content: space-around;
}

.Home .personal > div {
  width: 80vw;
  display: -webkit-flex;
  flex: 1;
  align-items: center;
}

.Home .identity > div {
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  align-self: center;
}

.identity > .portrait {
  flex: 1;
}

.identity > .portrait > img {
  width: 100%;
}

.identity > .account {
  display: -webkit-flex;
  flex-direction: column;
  flex: 2;
}

.account > span {
  display: -webkit-flex;
  flex: 1;
  align-items: center;
  width: 40vw;
  font-size: 22px;
}

.account > span:nth-child(1) {
  color: #434343;
}

.account > .gologin > span {
  display: -webkit-flex;
  width: 100px;
  height: 60px;
  background: #0097fe;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  color: white;
}

.exit {
  flex: 0.4;
}

.license {
  background: rgb(14, 118, 255);
  justify-content: center;
  border-radius: 10px;
  color: white;
}

.Home .tab {
  margin: 1rem auto;
  height: 20vh;
}

.Home .tab > div {
  flex: 1;
  display: -webkit-flex;
  flex-direction: column;
}

.tab > div > span {
  flex: 1;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
}

.tab > div:last-child {
  border-right: none;
}

.tab > div {
  border-right: 1px solid;
}

.tab > div > span:nth-child(1) {
  color: red;
  font-size: .45rem;
}

.tab > div > span:nth-child(2) {
  color: #434343;
  font-size: .45rem;
}

.code_wrap {
  flex: 1;
  background: #f2f2f2;
  justify-content: center;
  margin: 0 0 5vh 0;
}

.code_wrap > div {
  width: 20vw;
  height: 20vh;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.icon-saoyisaojianjiban {
  color: #0097fe;
  font-size: 1.3rem;
  height: 10vh;
}

.car_list {
  font-size: .45rem;
  justify-content: space-between;
  padding: 1vh 10vw;
}

.car_list:nth-child(2n-1) {
  background: #f2f2f2;
}

.car_list > span:nth-child(2) {
  color: red;
}

.Home > .nocar_num {
  width: 60vw;
  height: 40vh;
  border: 1px solid #0097fe;
  background: white;
  left: 20vw;
  position: absolute;
  top: 30vh;
  display: -webkit-flex;
  flex-direction: column;
  font-size: .6rem;
  justify-content: center;
  padding: 0;
}

.Home > .nocar_num > .nocar_num_text {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Home > .nocar_num > .nocar_num_bt {
  width: 100%;
  background: #0097fe;
  height: 8vh;
  line-height: 8vh;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue